module.exports = __webpack_public_path__ + "static/img/build-our-culture copy.8c12d33e.png";